import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/get_cities',
  options: { errorMessage: 'Не удалось получить список городов' },
});

export const useCitiesQuery = ({
  params: { serviceCompanyId } = {},
  options,
} = {}) =>
  useQuery({
    params: { serviceCompanyId },
    options: { enabled: Boolean(serviceCompanyId), ...options },
  });
